import { Button, Form, message } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import OTPInput from "react-otp-input";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { forgotPassword, verifyOtp } from "../../../controller/services/auth";
import i18n from "../../../localization/i18n";
import { setLoading } from "../../../redux/slices/common_slice";
import { routePaths } from "../../../routing/routePaths";
import { getApiErrorMessage } from "../../../utils/helper";
import CardWrapper from "./CardWrapper";

const VerificationCode = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const params = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [timer, setTimer] = useState(30);
  useEffect(() => {
    const intervalID = setInterval(() => {
      if (timer != 0) {
        setTimer((prev) => prev - 1);
      } else setTimer(0);
    }, 1000);
    return () => {
      clearInterval(intervalID);
    };
  }, [timer]);

  const onFinish = (values) => {
    dispatch(setLoading(true));
    const payload = {
      email: params.state?.email,
      otp: otp,
    };
    verifyOtp(payload)
      .then((resp) => {
        navigate(routePaths.resetPassword, {
          state: {
            email: params.state.email,
          },
        });
        message.success(resp?.message?.[i18n.language]);
      })
      .catch((err) => {
        message.error(getApiErrorMessage(err, t("errors.requestFailed")));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  const handleResend = () => {
    const payload = {
      email: params.state?.email,
    };
    forgotPassword(payload)
      .then((resp) => {
        setTimer(30);
        message.success(resp?.message?.[i18n.language]);
      })
      .catch((err) => {
        message.error(getApiErrorMessage(err, t("errors.requestFailed")));
      });
  };
  return (
    <CardWrapper>
      <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 mx-auto select-language-details">
        <a href={routePaths.forgotPassword} className="back-arrow-btn">
          <img
            alt=""
            className="img-fluid"
            src="/assets/images/icons/back-arrow-with-bg.svg"
          />
        </a>
        <h1>{t("verificationCode")}</h1>
        <p>
          {t("verificationCodeDesc")} <a href="">{params.state?.email}</a>
        </p>
        <div className="row">
          <div className="col-12 reset-password-form">
            <Form
              className="common-form"
              name="basic"
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item
                className="verification-code-item"
                label={false}
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Please input valid verification code!",
                  },
                ]}
              >
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={4}
                  renderInput={(props) => <input {...props} />}
                  inputStyle={{
                    width: "73px",
                    height: "73px",
                    borderRadius: "20px",
                    border: "1px solid #156fff4d",
                    padding: "0 27px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "26px",
                    color: "#000000",
                    fontWeight: 500,
                  }}
                  placeholder="------"
                  containerStyle={{
                    justifyContent: "space-between",
                    width: "70%",
                  }}
                />
              </Form.Item>
              <Form.Item>
                <p className="mb-0 code-descripation-tag">
                  {t("didntReceive")}{" "}
                  <a
                    onClick={() => {
                      if (timer == 0) {
                        handleResend();
                      }
                    }}
                    style={
                      timer != 0
                        ? {
                            opacity: 0.7,
                          }
                        : {}
                    }
                  >
                    {t("resend")}
                  </a>
                </p>
                <h5>
                  00:<span>{timer < 10 ? `0${timer}` : timer}</span>
                </h5>
              </Form.Item>
              <Form.Item>
                <Button
                  className="auth-theme-btn auth-login-btn auth-theme-btn-fix"
                  type="primary"
                  htmlType="submit"
                  disabled={otp?.length === 0}
                >
                  {t("verify")}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </CardWrapper>
  );
};

export default VerificationCode;
